/**
 * @architecture-header 1
 * @layer shared
 * @domain internationalisation
 * @responsibility Hold the Traditional Chinese to English string table.
 * @state-owner immutable module constant
 * @allowed-imports none
 * @forbidden runtime state; formatting logic; network
 * @public-api shared/lib/i18n
 * @side-effects none
 * @tests workspace-behaviour.test.ts
 */

export const TRANSLATIONS: Readonly<Record<string, string>> = {
  活動: 'Activity',
  正在載入收件匣: 'Loading inbox',
  班級: 'Classes',
  即時: 'Realtime',
  報告: 'Reports',
  作業: 'Assignments',
  我的班級: 'My classes',
  我的作業: 'My work',
  我的報告: 'My reports',
  老師: 'Teacher',
  學生: 'Student',
  成員: 'Members',
  新增: 'New',
  輸入指令或搜尋: 'Type a command or search',
  取消: 'Cancel',
  確認: 'Confirm',
  儲存: 'Save',
  刪除: 'Delete',
  關閉: 'Close',
  全部: 'All',
  開啟: 'Open',
  複製一份: 'Duplicate',
  複製連結: 'Copy link',
  更新: 'Update',
  發送: 'Send',
  核准: 'Approve',
  重新生成: 'Regenerate',
  匯出: 'Export',
  送出: 'Send',
  返回: 'Back',
  教材: 'Materials',
  解析中: 'Parsing',
  待確認: 'Pending',
  可用: 'Ready',
  已篩選: 'filtered',
  狀態: 'Status',
  答案來源: 'Answer source',
  有答案檔: 'Answer file',
  'AI 生成': 'AI generated',
  最近開啟: 'Recently opened',
  份: 'items',
  沒有: 'None',
  篩選: 'Filter',
  篩選條件: 'Filter by',
  全部清除: 'Clear all',
  項: 'selected',
  顯示方式: 'Display',
  清單: 'List',
  看板: 'Board',
  分組: 'Grouping',
  排序: 'Ordering',
  顯示屬性: 'Display properties',
  更新時間: 'Updated',
  名稱: 'Name',
  沒有符合的: 'No matches',
  'AI 答案': 'AI answers',
  題待確認: 'to review',
  全部已核准: 'All reviewed',
  題待核准: 'to review',
  參考原卷: 'Source paper',
  題目原卷: 'Question source',
  答案原卷: 'Answer source',
  題目: 'Questions',
  '原卷掃描第 1 頁': 'Source scan, page 1',
  '一邊編輯，一邊核對題目或答案原卷。': 'Edit while checking against the source paper.',
  已核准: 'Reviewed',
  待核准: 'Needs review',
  答案: 'Answer',
  概念: 'Concept',
  確認無誤: 'Confirm',
  改用原圖: 'Use image',
  '系統對這一題不確定，右邊對一次原卷再確認':
    'Not confident on this one. Check the source on the right.',
  點一下新增說明: 'Click to add instructions',
  題組: 'Question set',
  題數: 'Questions',
  總分: 'Total',
  姓名: 'Name',
  日期: 'Date',
  '第 1 頁 / 共 1 頁': 'Page 1 of 1',
  加入班級: 'Add to class',
  為某班改一份: 'Customize for a class',
  原版: 'Original',
  回顧: 'Review',
  活動回顧: 'Activity review',
  學習報告: 'Learning report',
  發放: 'Assign',
  邀請學生: 'Invite students',
  複製加入連結: 'Copy invite link',
  加入連結: 'Invite link',
  或給他們這組代碼: 'or give them this code',
  重新生成代碼: 'Regenerate code',
  '任何拿到連結的人都可以加入這個班。': 'Anyone with this link can join this class.',
  派發: 'Runs',
  方式: 'Mode',
  人數: 'Students',
  紀錄: 'Records',
  其他班: 'Other classes',
  課堂進行: 'In class',
  指派作業: 'Homework',
  進行中: 'In progress',
  收件中: 'Collecting',
  已結束: 'Ended',
  已發送: 'Sent',
  待審: 'To review',
  上課中: 'In class now',
  這個班的版本: 'This class version',
  為這個班客製化: 'Customized for this class',
  還原成原版: 'Reset to original',
  上課: 'Session',
  複製加入代碼: 'Copy join code',
  指派給這些人: 'Assign to selected',
  已選: 'Selected',
  對象: 'Recipients',
  整個班級: 'Entire class',
  指定學生: 'Specific students',
  到班級的學生分頁勾選: 'Pick them on the Students tab',
  '現在帶著上。即時面板會顯示每個人在哪一題，卡住的排進介入佇列。':
    'Run it now. The live board shows where everyone is and queues whoever gets stuck.',
  '學生自己找時間寫，不會出現在即時面板，到截止再收。':
    'Students work on their own time. Not shown on the live board.',
  開始課堂進行: 'Start live',
  指派為作業: 'Assign as homework',
  選擇要發放的教材: 'Which one',
  需要你: 'Needs you',
  'AI 支援中': 'AI helping',
  作答中: 'Working',
  已完成: 'Done',
  需要老師接手: 'Needs teacher',
  '卡住 3 分鐘': 'Stuck 3 min',
  提示後自己修正: 'Recovered after a hint',
  還沒進來: 'Not joined',
  介入: 'Step in',
  結束: 'End',
  順利: 'On track',
  '每 2 秒更新': 'updates every 2s',
  複製學生連結: 'Copy student link',
  結束這堂: 'End this session',
  只結束: 'End only',
  結束並開一份補交: 'End and open a make-up',
  '連結立刻失效，沒進來的學生就進不來了。': 'The link expires immediately.',
  '原連結失效，另外產生一份作業，開到今晚 23:59。':
    'The live link expires and a homework run opens until 23:59.',
  確認結束: 'Confirm end',
  疑似問題: 'Suspected issue',
  他現在寫的: 'What they wrote',
  傳一段話給他: 'Send them a line',
  用一句話點出他卡住的那一步: 'One line pointing at the step they are stuck on',
  標記已解決: 'Mark resolved',
  這堂課: 'This session',
  他這學期: 'This term',
  檢視完整學習報告: 'Open learning report',
  'AI 已經做過': 'AI already tried',
  為什麼交給你: 'Why it came to you',
  '送出後 AI 會接著這句話繼續陪他做完，不會重新從頭問。':
    'After you send, the AI continues from your line.',
  收卷: 'Collect',
  作答進度: 'Progress',
  結束收件: 'Close collection',
  已交: 'Submitted',
  逐份核准: 'Review one by one',
  已通過: 'approved',
  全部核准: 'Approve all',
  這次的共同卡點: 'Shared sticking points',
  每次上課一份: 'One per session',
  'AI 自己解決': 'AI resolved',
  你介入: 'You stepped in',
  仍未解決: 'Still unresolved',
  展開: 'Expand',
  收合: 'Collapse',
  檢視學習報告: 'Open learning report',
  自己答對的比率: 'Independent accuracy',
  不含提示後才對的: 'excludes hint-assisted',
  進步最多: 'Most improved',
  最需要練: 'Needs practice',
  證據: 'Evidence',
  評語: 'Comment',
  這段時間的活動: 'Activities in this period',
  '近 30 天': 'Last 30 days',
  需要注意: 'Needs attention',
  同班同學: 'Classmates',
  '只看得到名字，看不到別人的成績。': 'You can see names only, not their scores.',
  進去上課: 'Join class',
  跟上進度: 'Catch up',
  老師正在上課: 'Your teacher is teaching now',
  項待完成: 'to do',
  項已完成: 'done',
  'AI 陪你': 'AI helped you',
  老師來幫你: 'Teacher helped you',
  我需要老師: 'I need a teacher',
  關閉助教: 'Close tutor',
  檢查這一步: 'Check this step',
  上一題: 'Previous',
  下一題: 'Next',
  交卷: 'Submit',
  我的計算: 'My work',
  時間: 'Time',
  進度: 'Progress',
  我的答案: 'My answer',
  正解: 'Correct answer',
  結果: 'Result',
  答對: 'Correct',
  答錯: 'Wrong',
  老師的話: 'From your teacher',
  開始訂正: 'Start corrections',
  看回顧: 'Open recap',
  看我的作答: 'See my answers',
  當時發生什麼: 'What happened',
  你進步的地方: 'What improved',
  下次要練什麼: 'What to practice',
  開始練習: 'Start practice',
  要訂正: 'Needs fixing',
  還沒交: 'Not submitted',
  得分: 'Score',
  我在的班: 'My classes',
  待完成: 'To do',
  加入: 'Join',
  加入班級並開始: 'Join and start',
  加入並進入課堂: 'Join the live session',
  這個連結已經失效: 'This link has expired',
  '用 Google 繼續': 'Continue with Google',
  '用 Email 登入': 'Sign in with email',
  '已為這個班建立獨立版本，之後改這一份不影響原版':
    'Created a class-only version. Editing it will not affect the original.',
  已還原成原版: 'Reset to the original',
  題: 'questions',
  'AI 再提示：把 -3 移到等號右邊，它會變成什麼？':
    'AI hinted again: move -3 to the right side. What does it become?',
  'AI 助教': 'AI tutor',
  'AI 提示過': 'AI hinted',
  'AI 提示：移項的時候，符號要跟著一起改變': 'AI hint: when you move a term, its sign flips',
  'AI 陪你想通的那幾題，老師那邊也看得到。':
    'Your teacher can see which ones the AI helped you through.',
  上一頁: 'Previous page',
  下一頁: 'Next page',
  上升到: 'to',
  上週: 'Last week',
  交出去了: 'Submitted',
  人: 'students',
  今天: 'Today',
  '今天 19:00': 'Today 19:00',
  '今天 19:10': 'Today 19:10',
  '今天 19:40': 'Today 19:40',
  '今天 補交': 'Today make-up',
  作: 'H',
  作業連結: 'Homework link',
  '你寫下 <b>5x + 2x = 9 + 3</b>': 'You wrote <b>5x + 2x = 9 + 3</b>',
  '你寫下 <b>7x = 12</b>': 'You wrote <b>7x = 12</b>',
  '你自己改成 <b>5x - 2x = 9 + 3</b>，答對了':
    'You fixed it to <b>5x - 2x = 9 + 3</b> and got it right',
  '你這一步的 -3 去哪了？': 'Where did the -3 in this step go?',
  '你開始寫第 4 題': 'You started question 4',
  '個百分點。': ' points.',
  '先別算，等號兩邊各加 3 看看': 'Before solving, add 3 to both sides',
  先寫一句話: 'Write a line first',
  分配律: 'Distributive property',
  '到班級的活動分頁按「發放」，選課堂進行，這裡就會出現。':
    'Assign an activity from a class and pick In class. It will show up here.',
  '到班級的活動分頁發一份課堂進行。': 'Assign an In-class activity from a class.',
  剛剛: 'just now',
  副本: ' copy',
  動作: 'Actions',
  勾選: 'Select',
  '化簡 4x + 2x - 3': 'Simplify 4x + 2x - 3',
  卷面: 'Paper',
  去即時: 'Go to Realtime',
  去報告: 'Go to Reports',
  去活動: 'Go to Activities',
  去班級: 'Go to Classes',
  合併同類項: 'Combining like terms',
  命令面板: 'Command palette',
  '回到 100%': 'Reset to 100%',
  圖片: 'Image',
  執行: 'run',
  報: 'R',
  導覽: 'Navigation',
  展開清單: 'Expand list',
  '左邊挑一位學生。': 'Pick a student on the left.',
  '左邊挑一次上課。': 'Pick a session on the left.',
  已交出: 'Submitted',
  已儲存: 'Saved',
  '已切換到近 90 天': 'Switched to last 90 days',
  已刪除: 'Deleted',
  已刪除答案附件: 'Answer key deleted',
  已加入我的作業: 'Added to my work',
  已失效: 'Expired',
  已復原: 'Undone',
  '已指派為作業，截止今晚 23:59': 'Assigned as homework, due 23:59 tonight',
  '已改用原圖，不切題': 'Switched to image mode',
  已更名: 'Renamed',
  '已核准，可以發送': 'Approved, ready to send',
  已標記解決: 'Marked resolved',
  已發送給家長: 'Sent to parents',
  已結束收件: 'Collection closed',
  '已結束，回顧報告產生中': 'Ended. Generating the review.',
  '已結束，補交作業已開啟': 'Ended. Make-up homework is open.',
  已經在這個班: 'Already in this class',
  已經在這個班了: 'Already in this class',
  已複製一份: 'Duplicated',
  已複製連結: 'Link copied',
  '已送出，AI 接手續陪': 'Sent. The AI takes it from here.',
  已重做: 'Redone',
  已重新排入解析: 'Queued for parsing again',
  已重新生成: 'Regenerated',
  已重新生成代碼: 'Code regenerated',
  已開啟訂正: 'Corrections opened',
  已附答案檔: 'Answer key attached',
  復原: 'Undo',
  '我選了 (': 'I chose (',
  '把 -3 移到右邊，符號會變成什麼？': 'Move -3 to the right. What sign does it take?',
  收合清單: 'Collapse list',
  放大: 'Zoom in',
  昨天: 'Yesterday',
  更多: 'More',
  有人需要你: 'Someone needs you',
  有待審報告: 'Reports to review',
  '未命名檔案.pdf': 'untitled.pdf',
  移項變號: 'Sign change when moving terms',
  列式: 'Setting up equations',
  比例式: 'Proportions',
  縮小: 'Zoom out',
  '7 月 18 日': 'Jul 18',
  '7 月 20 日': 'Jul 20',
  '7 月 22 日': 'Jul 22',
  '7 月 27 日': 'Jul 27',
  '10 分鐘前': '10 min ago',
  '3 天前': '3 days ago',
  '2 週前': '2 wks ago',
  '3 週前': '3 wks ago',
  '4 週前': '4 wks ago',
  '5 週前': '5 wks ago',
  '6 週前': '6 wks ago',
  本週: 'This wk',
  '88 分': '88 pts',
  '92 分': '92 pts',
  '2 人': '2',
  '3 人': '3',
  '47% · 近三週錯 5 次': '47% · 5 errors in 3 weeks',
  人需要你: 'need you',
  第: 'Q',
  寫到第: 'On Q',
  教材庫: 'Open library',
  我帶的班級: 'My classes',
  班: 'C',
  課: 'L',
  正在進行: 'Live now',
  題字: 'Q',
  班字: 'C',
  活字: 'A',
  報字: 'R',
  回字: 'R',
  課字: 'L',
  作字: 'H',
  師字: 'T',
  版本: 'Version',
  從: 'From',
  六週進步: 'up',
  個百分點: 'points over 6 weeks',
  題完成: 'questions done',
  題沒用提示: 'without hints',
  次老師介入: 'teacher interventions',
  同班: 'Classmates',
  次: 'times',
  課堂進行中: 'Live now',
  '今晚 23:59 截止': 'Due 23:59 tonight',
  這次: 'This time',
  訂正後: 'After corrections',
  移項未變號: 'sign not flipped',
  原題: 'Question',
  '第 3-2 題': 'Q3-2',
  '移項變號。把一項搬到等號另一邊時沒有改變符號。':
    'Sign change when moving terms. The sign did not flip when a term crossed the equals sign.',
  '連續兩次保留同一個錯誤，AI 判斷再提示也不會前進。':
    'Same error twice in a row. The AI judged that more hints will not move them forward.',
  '直接規則：移項時符號會相反': 'Direct rule: signs flip when you move a term',
  '天平比喻：兩邊同時拿走 -3': 'Balance analogy: take -3 from both sides',
  評語範本:
    ' has improved clearly at setting up equations over six weeks and usually self-corrects after one hint. The priority now is sign changes when moving terms: the same mistake appeared five times in three weeks. Six same-type questions a day on that one concept.',
  評語卡關:
    ' got stuck on sign changes this time, made the same mistake twice, the teacher stepped in once and they fixed it themselves afterwards. Six same-type questions at home.',
  評語穩定:
    ' was steady this time and worked it out after one hint. Ready to move on to word problems.',
  分: 'pts',
  也在: 'also in',
  活: 'A',
  回: 'R',
  師: 'T',
  日: '',
  月: '/',
  週前: 'wks ago',
  全部教材: 'All materials',
  只看這個班: 'Show this class only',
  前往班級: 'Open class',
  回教材清單: 'Back to materials',
  上一個待核准: 'Previous to review',
  下一個待核准: 'Next to review',
  沒有待核准的題目: 'Nothing left to review',
  '班級 QR 邀請': 'Class QR invite',
  '課堂 QR 邀請': 'Live session QR',
  '作業 QR 連結': 'Homework QR link',
  'QR 與連結': 'QR and link',
  'QR 與加入連結': 'QR and invite link',
  'QR 與學生連結': 'QR and student link',
  '連結外流時請立即重置。': 'Reset immediately if the link leaks.',
  重置連結: 'Reset link',
  '已重置連結，舊連結立刻失效': 'Link reset. The old link no longer works.',
  複製: 'Copy',
  已複製一份給: 'Copied to',
  編輯這一份: 'Edit this one',
  這一份的學生連結: 'Student link for this one',
  班級加入連結: 'Class invite link',
  '這是班級加入連結，學生加入後所有活動都會出現在他的清單。':
    'Class invite link. Once they join, every activity shows up in their list.',
  '這是這一份活動專用的連結，跟班級加入連結不一樣，只會進到這一份。':
    'Link for this activity only. Different from the class invite: it opens just this one.',
  確認並產生評語: 'Confirm and write comment',
  已依作答產生評語: 'Comment generated from the marking',
  點右邊的圈可以改判對錯: 'Use the circles to change the marking',
  判定: 'Mark',
  判定答對: 'Mark correct',
  判定答錯: 'Mark wrong',
  學生作答: 'Their answer',
  已檢視作答: 'Answers checked',
  尚未檢視: 'Not reviewed yet',
  可核准: 'Ready',
  待檢視: 'To review',
  檢視作答: 'Open answers',
  檢視作答狀況: 'Open their answers',
  請先檢視作答再生成評語: 'Review their answers first',
  '評語依據你判定的對錯自動生成，請先確認每一題。':
    'The comment is generated from your marking, so confirm every question first.',
  請先檢視作答再核准: 'Review the answers first',
  人尚未檢視作答: 'still need review',
  評語前綴: ' scored ',
  評語中段: ' this time. ',
  評語結尾: ' need more practice.',
  評語全對: 'Everything correct. Ready to move on.',
  訂正後答對: 'Fixed after retry',
  待老師確認: 'Needs your call',
  題還沒判定: 'still unjudged',
  題訂正後答對: ' fixed after retry. ',
  學生開始作答: 'Started',
  學生寫下: 'Wrote',
  一次就寫對: 'Correct first try',
  'AI 提示': 'AI hint',
  學生改寫: 'Rewrote',
  '學生寫了另一種寫法，AI 無法判定': 'Used a different form the AI could not judge',
  學生自己標記為需要老師確認: 'Student flagged it for the teacher',
  學生仍然保留同一個錯誤: 'Kept the same mistake',
  'AI 判斷再提示也不會前進，交給老師': 'AI judged more hints would not help',
  這一題的完整對話: 'Full log for this question',
  原卷: 'Source',
  原卷第: 'Source page',
  頁: '',
  評語提示詞: 'Comment prompt',
  提示詞: 'Prompt',
  '課後評語 · 每次活動結束後產生': 'After-class comment, generated when an activity ends',
  '學習報告評語 · 跨多次活動的月度評語': 'Learning report comment, monthly across activities',
  已客製化: 'Customized',
  目前使用預設: 'Using the default',
  還原成預設: 'Reset to default',
  已還原成預設提示詞: 'Reset to the default prompt',
  可用變數: 'Variables',
  點一下插入: 'click to insert',
  語氣: 'Tone',
  長度: 'Length',
  鼓勵: 'Encouraging',
  中性: 'Neutral',
  嚴格: 'Strict',
  簡短: 'Short',
  標準: 'Standard',
  詳細: 'Detailed',
  預覽: 'Preview',
  儲存並套用: 'Save and apply',
  '提示詞已儲存，之後產生的評語會照這個寫': 'Prompt saved. Future comments will follow it.',
  語氣鼓勵: 'Keep it encouraging',
  語氣嚴格: 'Be direct',
  評語詳細補充: ' Practise six same-type questions a day and check the working step by step.',
  報告簡短版: ' is trending up. Focus on sign changes when moving terms.',
  報告詳細補充: ' Evidence: 18 questions done, 11 without hints, 3 teacher interventions.',
  學生姓名: 'Student name',
  '答對題數 / 總題數': 'Correct / total',
  訂正後答對的題數: 'Fixed after retry',
  判定為答錯的概念清單: 'Concepts marked wrong',
  活動名稱: 'Activity name',
  六週前的自己答對比率: 'Rate six weeks ago',
  本週的自己答對比率: 'Rate this week',
  進步最多的概念: 'Most improved concept',
  最需要加強的概念: 'Concept needing work',
  完成題數與提示次數: 'Questions done and hints used',
  分數: 'Score',
  訂正數: 'Fixed',
  錯誤概念: 'Wrong concepts',
  起始比率: 'Start rate',
  目前比率: 'Current rate',
  進步概念: 'Improved',
  加強概念: 'Needs work',
  家長: 'Guardian',
  家長綁定: 'Guardian link',
  已綁定: 'Linked',
  邀請待確認: 'Invite pending',
  未綁定: 'Not linked',
  的家長: 'guardian',
  已連結的家長: 'Linked guardians',
  還沒有家長綁定: 'No guardian linked yet',
  '這位學生的報告目前沒有人收得到。': 'Nobody receives this student report right now.',
  再產生一組邀請: 'Create another invite',
  完成: 'Done',
  '已產生家長邀請，請把連結或 QR 給家長': 'Invite created. Send the link or QR to the guardian.',
  家長已完成綁定: 'Guardian linked',
  模擬家長完成綁定: 'Simulate guardian linking',
  等待綁定: 'Waiting to link',
  '報告只會寄給已綁定的家長。家長掃這個 QR 或開連結，確認是這位學生的家長之後就完成綁定。':
    'Reports only go to linked guardians. The guardian scans this QR or opens the link and confirms they are this student guardian.',
  有幾位還沒有家長綁定: 'Some students have no guardian',
  份可以寄出: 'can be sent',
  份沒有收件人: 'have no recipient',
  '沒有綁定家長的學生，報告會先留著，等家長綁定之後再寄。':
    'Reports for unlinked students are held until a guardian links.',
  產生家長邀請: 'Create guardian invite',
  先寄出可以寄的: 'Send the ones that can go',
  筆給家長: 'to guardians',
  簡訊: 'SMS',
  移除: 'Remove',
  已移除: 'Removed',
  用哪個管道送給家長: 'Which channel to reach the guardian',
  '連結是同一組，管道只是把它送出去的方式。':
    'The link is the same. The channel is just how it gets delivered.',
  '加好友後用官方帳號推播，可以放卡片與按鈕':
    'Official account push after they add you. Supports cards and buttons.',
  '用 Business 範本訊息推播，家長回覆後才能自由對話':
    'Business template messages. Free-form chat only after they reply.',
  '服務號模板消息，需要中國主體': 'Service account template messages. Requires a China entity.',
  '最通用但只能放短連結，成本最高': 'Works everywhere but only a short link, and costs the most.',
  用: 'Send via',
  送出邀請: '',
  全班家長綁定: 'Class guardian linking',
  '三種收法，看你手上有什麼': 'Three ways, depending on what you already have',
  匯入名冊: 'Import roster',
  '補習班報名資料本來就有家長手機，匯入後系統直接發邀請，老師零操作':
    'Enrolment data already has guardian numbers. Import once and invites go out automatically.',
  列印邀請單: 'Print invite slips',
  '一人一張，含專屬 QR 與六位數綁定碼，讓學生帶回家':
    'One slip per student with a personal QR and a 6-digit code to take home.',
  請學生自己邀請: 'Let students invite',
  '學生端出現「邀請我的家長」，家長掃他手機上的 QR':
    'Students get an Invite my guardian button and the guardian scans it on their phone.',
  還沒綁定的: 'Not linked yet',
  單獨處理: 'Handle individually',
  '全班都綁好了。': 'The whole class is linked.',
  邀請這: 'Invite these',
  已用: 'Sent via',
  '送出邀請，家長確認後才算綁定': 'invites. Linking completes once the guardian confirms.',
  '已開啟名冊匯入，欄位: 學生姓名、家長姓名、關係、手機或 LINE ID':
    'Roster import opened. Columns: student, guardian, relationship, phone or LINE ID.',
  '已產生全班邀請單 PDF，一人一張含 QR 與綁定碼':
    'Invite slips generated, one page per student with QR and code.',
  '已在學生端開啟「邀請我的家長」': 'Invite my guardian is now visible to students.',
  人還沒收到邀請: 'not invited yet',
  一次處理: 'Handle all',
  綁定碼: 'Parent code',
  '同一組碼最多四位家長各自使用，綁定後所有班級都適用，不用重綁。':
    'One code works for up to four guardians, and once linked it covers every class the student is in.',
  等你確認的請求: 'Requests waiting for you',
  通過: 'Approve',
  拒絕: 'Decline',
  '已通過，這位家長現在收得到報告': 'Approved. This guardian now receives reports.',
  已拒絕這筆請求: 'Request declined',
  有一筆家長綁定請求等你確認: 'A guardian request is waiting for you',
  模擬家長送出請求: 'Simulate a guardian request',
  自稱: 'claims to be',
  已驗證: 'Verified',
  筆家長請求等你確認: 'guardian requests waiting',
  '班級連結是公開的，一定要你確認過才算綁定':
    'A class link is public, so every request needs your approval.',
  報名表: 'Enrolment form',
  '從補習班報名資料匯入，號碼是家長自己留的':
    'Imported from enrolment data, where the guardian gave the number themselves',
  老師輸入: 'Teacher entered',
  老師手動輸入的聯絡方式: 'Contact the teacher typed in',
  學生提供: 'From the student',
  '學生在自己的裝置上出示 QR 給家長掃': 'The student showed the QR on their own device',
  公開連結: 'Public link',
  '掃班級 QR 或拿到轉傳連結自己來的，系統不知道他是誰':
    'Came in via the class QR or a forwarded link. The system does not know who they are.',
  來源: 'Source',
  與報名表比對: 'Against enrolment',
  號碼相符: 'Number matches',
  號碼不符: 'Number does not match',
  報名表上的家長號碼就是這一支: 'This is the guardian number on the enrolment form',
  '報名表上不是這支號碼，可能換號也可能不是本人':
    'Not the number on file. Could be a new number, could be someone else.',
  '（自己填的）': ' (self-declared)',
  問學生: 'Ask the student',
  已在學生端問他這是不是他的家長: 'Asked the student to confirm on their side',
  模擬公開連結來的請求: 'Simulate a public-link request',
  邀請我的家長: 'Invite my guardian',
  讓家長收到你的學習報告: 'So your guardian receives your reports',
  '你不用輸入家長的手機或帳號。把下面的 QR 或連結給家長，聯絡方式由家長自己在頁面上填，這樣才不會填錯，也不會有人代填別人的個資。':
    'You do not enter your guardian contact. Hand them this QR or link and they fill in their own details, so nothing gets mistyped and nobody enters someone else personal data.',
  傳給家長: 'Send to guardian',
  檢視家長端畫面: 'See what they see',
  目前已綁定: 'Currently linked',
  '家長綁定之後，老師發的報告他就收得到。':
    'Once linked, they receive the reports your teacher sends.',
  '已開啟分享，選一個聊天軟體傳給家長': 'Share sheet opened. Pick an app to send it.',
  家長會看到的畫面: 'What your guardian sees',
  這是家長開啟連結之後的三個步驟: 'Three steps after they open the link',
  確認身分: 'Confirm who they are',
  你是: 'Are you',
  '的家長嗎？': 'guardian?',
  王維青老師: 'Ms. Wang',
  '是，我是': 'Yes, I am',
  我不是: 'I am not',
  填自己是誰: 'Fill in their own details',
  '姓名與關係，由家長自己填': 'Name and relationship, entered by them',
  陳美惠: 'Chen Mei-hui',
  媽媽: 'Mother',
  選自己要用哪個管道收: 'Pick how they want to receive',
  '加入 Vispo 官方帳號好友': 'Add the Vispo official account',
  '家長按下去會加你的 LINE 官方帳號，系統這時才拿得到他的 LINE userId。注意: 使用者看得到的那個 LINE ID 不能拿來發訊息。':
    'Adding the official account is what gives you their LINE userId. The visible LINE ID cannot be used to send messages.',
  傳一則訊息給我們: 'Send us a message',
  '家長點下去會開啟 WhatsApp 並帶一則預填訊息，送出後我們才有他的號碼，也才開啟 24 小時對話窗口。':
    'Opens WhatsApp with a prefilled message. Sending it gives us their number and opens the 24-hour window.',
  關注服務號: 'Follow the service account',
  '家長掃碼關注你的 WeChat 服務號，之後用模板消息推播。':
    'They scan to follow your WeChat service account, then you push template messages.',
  填手機號碼: 'Enter a phone number',
  '唯一需要家長自己輸入號碼的管道，填完會收到一次性驗證碼。':
    'The only channel where they type a number, followed by a one-time code.',
  已經綁定好了: 'Already linked',
  家長綁定之後才收得到你的報告: 'They receive your reports once linked',
  還沒綁定: 'Not linked',
  家: 'G',
  當面出示: 'Show in person',
  '請家長掃這個 QR': 'Ask the guardian to scan this',
  '你現在是當面出示，所以掃進來的綁定會直接成立，不用再審核。':
    'You are showing this in person, so a scan links immediately with no approval needed.',
  '離開這個畫面之後掃進來的就會變成待核准。':
    'Scans after you close this screen go to the approval queue.',
  模擬家長掃了: 'Simulate a scan',
  '當面掃的，直接綁定完成，不用審核': 'Scanned in person. Linked immediately, no approval needed.',
  '當面出示給家長掃是最可靠的，因為你看得到是誰掃的，這種不用再審核。':
    'Showing it in person is the most reliable: you can see who scans it, so no approval is needed.',
  學生加入畫面: 'What students see',
  班級邀請: 'Class invite',
  課堂連結: 'Live link',
  '這個活動已經結束，邀請連結不再有效。':
    'This activity has ended and the link is no longer valid.',
  '老師結束之前都可以進來。': 'You can join until the teacher ends it.',
  '開放期間隨時可以寫。': 'You can work on it any time while it is open.',
  '同一個 route 依 token 類型換內容，不做三套頁面。':
    'One route, content varies by token type. No separate pages.',
  預覽學生看到的畫面: 'Preview student view',
  已登入: 'Signed in',
  未加入班級: 'Not in any class',
  個班: 'classes',
  個班級: 'classes',
  位學生: 'students',
  次上課: 'sessions',
  項進行中: 'live now',
  現在沒有課在上: 'No live sessions',
  依班級分組: 'Grouped by class',
  老師指派給你的: 'Assigned to you',
  '左邊挑一份開始寫。': 'Pick one on the left.',
  快捷鍵: 'Shortcuts',
  所有快捷鍵: 'All shortcuts',
  前往: 'Go to',
  移動: 'move',
  找不到符合的: 'No matches',

  // Next-lesson panel.
  洞察: 'Insight',
  整體表現: 'Overall performance',
  次已批改: 'graded',
  全班平均答對率: 'Class average correct rate',
  中位數: 'Median',
  每一欄是落在該分數區間的學生人數: 'Each column counts the students in that score band',
  還沒開始: 'Not started',
  '這個班還沒有指派活動。': 'Nothing has been assigned to this class yet.',
  對應觀念: 'Standards tagged',
  依題目標記的觀念聚合: 'Grouped by the concept tagged on each question',
  全班平均: 'Class average',
  最需要補強的題目: 'Top underperforming questions',
  答對率由低到高: 'Lowest correct rate first',
  人答錯: 'missed it',
  題型表現: 'Item type performance',
  同一份活動裡的不同問法: 'The different ways this activity asks',
  評分規準表現: 'Rubric performance',
  每一格是一次批改結果: 'Each segment is one marked answer',
  背景分布: 'Demographics',
  需要學校端提供分組資料: 'Needs grouping data from the school',
  '這個工作區沒有蒐集學生的背景屬性，所以沒有可以比較的分組。':
    'This workspace collects no student background attributes, so there are no groups to compare.',
  '這個班還沒有批改完成的活動，先發一份下去。':
    'No marked activity in this class yet. Send one out first.',
  計算題: 'Computation',
  應用題: 'Application',
  化簡題: 'Simplification',
  待加強: 'Needs work',
  需確認: 'Needs a check',
  訂正後正確: 'Right after correcting',
  精熟: 'Mastered',

  // Run-scoped insight and the per-student mark tally.
  作業洞察: 'Activity insight',
  只看這一份: 'this activity only',
  '這份作業還沒有批改結果。': 'Nothing has been marked in this activity yet.',
  訂正: 'Fixed',

  // Live seat statuses: offline, online, answering, stuck for N minutes, needs the teacher.
  離線: 'Offline',
  線上: 'Online',
  卡住: 'Stuck for',
  分鐘: 'min',

  // AI assistant personas.
  帳號: 'Account',
  偏好設定: 'Preferences',
  介面語言: 'Interface language',
  正在載入偏好設定: 'Loading preferences',
  '更新失敗，請重試': 'Update failed, please retry',
  重新整理: 'Refresh',
  已被他人修改: 'Changed by someone else',
  '儲存中…': 'Saving…',
  組織名稱: 'Organization name',
  正在載入組織設定: 'Loading organization settings',
  刪除組織: 'Delete organization',
  '目前尚未提供自助刪除組織的流程。如需刪除組織，請透過下方聯絡我們與我們聯繫，我們會協助您完成後續程序。':
    'A self-serve delete flow is not available yet. To delete this organization, please contact us below and we will help you through the process.',
  聯絡我們: 'Contact us',
  新增助教: 'New assistant',
  未命名助教: 'Untitled assistant',
  還沒設定完: 'Not finished yet',
  預設: 'Default',
  設為預設助教: 'Make this the default',
  '派發活動時可以指定其中一位。沒有指定的活動一律由預設助教接手。':
    'Pick one when you assign an activity. Anything without a pick goes to the default.',
  身分: 'Identity',
  名字: 'Name',
  一句話介紹: 'One-line intro',
  角色設定: 'Who they are',
  '他是誰、怎麼看待學生、遇到卡住的人會先做什麼':
    'Who they are, how they see students, what they do first when someone is stuck',
  個性: 'Personality',
  溫暖鼓勵: 'Warm',
  冷靜清楚: 'Calm',
  幽默陪伴: 'Playful',
  嚴格教練: 'Coach',
  '先接住情緒，再帶下一步': 'Settles the student first, then moves on',
  '不寒暄，把理由講清楚': 'No small talk, states the reasoning',
  用比喻和玩笑降低壓力: 'Uses jokes and metaphors to lower the pressure',
  '要求說出依據，節奏快': 'Asks for the reason, keeps the pace up',
  溫暖: 'Warmth',
  幽默: 'Humour',
  簡潔: 'Brevity',
  就事論事: 'matter of fact',
  先安撫再教: 'reassures first',
  正經: 'serious',
  愛開玩笑: 'jokes a lot',
  順著學生走: 'follows the student',
  要求說出理由: 'asks for reasons',
  講得很細: 'explains in detail',
  一兩句就停: 'one or two lines',
  說話方式: 'How they speak',
  怎麼稱呼學生: 'What they call the student',
  口頭禪: 'Catchphrase',
  表情符號: 'Emoji',
  不用: 'None',
  偶爾: 'A little',
  很多: 'A lot',
  開場白: 'Opening line',
  教學規則: 'Teaching rules',
  提示幾次後交給老師: 'Hints before handing over',
  永遠不給答案: 'Never give the answer',
  提示用完才給: 'Only after the hints run out',
  絕對不要做的事: 'Never do this',
  '例如：不要直接寫出答案、不要說「很簡單」':
    'e.g. never write the final answer, never say it is easy',
  特定回覆: 'Set replies',
  '學生說出左邊那句話時，助教一定用右邊這句回。':
    'When a student says the line on the left, the assistant answers with the line on the right.',
  學生說: 'Student says',
  助教回: 'Assistant replies',
  加一條: 'Add one',
  刪掉: 'Delete',
  已刪掉: 'deleted',
  還有欄位沒填完: 'Some fields are still empty',
  還沒命名: 'Not named yet',
  一句話介紹會出現在派發時的選單: 'The one-line intro shows up in the assignment picker',
  開場白會是學生看到的第一句話: 'The opening line is the first thing the student reads',
  '這一區還沒接上，先從 AI 助教開始設定。':
    'This section is not wired up yet. Start with the AI assistant.',

  // Next-lesson panel.
  下一堂課: 'Next lesson',
  次評量: 'papers',
  筆有效作答: 'marked answers',
  題可跨卷比較: 'questions comparable across papers',
  錯誤模式: 'Error patterns',
  排入講解: 'Reteach this',
  建立分組: 'Group them',
  排入複習: 'Reteach',
  已排入: 'Planned',
  指派給這: 'Assign to these',
  人在: 'students failed it in',
  次評量都沒通過: 'papers',
  影響: 'Affects',
  較上次退步: 'down',
  較上次持平或進步: 'flat or up',
  會卡在這裡: 'is blocked behind this',
  看: 'See',
  位學生的作答: "students' answers",
  概念跨考卷趨勢: 'Concept trend across papers',
  已掌握的概念: 'Concepts already solid',
  介入後追蹤: 'After the intervention',
  生成摘要: 'Write a summary',
  '只出現在一次評量、無法比較': 'Only in one paper, not comparable',
  沒有跨考卷都卡住的概念: 'No concept is stuck across papers',
  '下一堂可以照原訂進度走。等這個班多考一份再回來看。':
    'Carry on as planned. Come back after another paper.',
  '這幾次評量沒有重複出現的錯法。': 'No error repeats across these papers.',
  '還沒有概念穩定在八成以上。': 'No concept is holding above 80% yet.',
  '還沒有記錄任何介入。從上面的卡片指派之後，這裡會出現前後對照。':
    'No intervention recorded yet. Assign from a card above and the before/after shows up here.',
  此班級尚無可指派的教材: 'This class has no material to assign yet',
  已排進下一堂課: 'added to next lesson',
  括號沒有乘開就移項: 'Moved terms before expanding the bracket',
  '把對稱軸當成零點，移項沒變號': 'Moved a term without flipping its sign',
  內項外項相乘弄反: 'Cross-multiplied the wrong pair',
  把常數項也一起合併: 'Merged the constant into the like terms',

  // Activity archive and tags.
  已封存: 'Archived',
  封存: 'Archive',
  取消封存: 'Unarchive',
  已取消封存: 'Unarchived',
  標籤: 'Tags',
  建立時間: 'Created',
  這份的標籤: 'Tags on this one',
  '還沒有標籤。': 'No tags yet.',
  新標籤: 'New tag',
  '輸入後按 Enter': 'Type and press Enter',
  已經用過的標籤: 'Tags you have used',
  已更新標籤: 'Tags updated',
  已清空標籤: 'Tags cleared',
  較上次進步: 'up',
  與上次持平: 'flat since last time',

  // Assignment report.
  學生一覽: 'Students',
  逐題: 'By question',
  錯法: 'Error routes',
  跨兩題以上才顯示: 'shown once it spans two questions',
  共: 'of',
  看這: 'See these',
  建立補強練習並指派: 'Create follow-up and assign',
  列印: 'Print',
  報表判讀說明: 'How to read this',
  知道了: 'Got it',
  '同一張表，用對地方和用錯地方差很多': 'The same table, used right and used wrong',
  適合拿來做的事: 'Fit for',
  不適合拿來做的事: 'Not fit for',
  已答: 'Answered',
  答對最少: 'Fewest right',
  最需注意: 'Watch',
  '這次評量每個錯法只出現在一題，還不能聚合。':
    'Every error route here appears on one question only, so nothing can be aggregated yet.',
  '找出這一次最多人卡住的題目，決定下一堂先講哪一題。':
    'Find the question that stopped the most students and decide what to open with.',
  '挑出需要個別檢視作答的學生，點名字直接進去看他寫了什麼。':
    'Pick students to look at individually; click a name to read what they wrote.',
  '在收齊之前，先掌握進度，判斷要不要延長時間。':
    'Check progress before everything is in, and decide whether to extend.',
  '判斷某個學生的概念掌握程度。一題答錯不等於不會。':
    'Judging whether a student has a concept. One wrong answer is not an answer.',
  '比較兩個班或兩次評量。這張表只描述這一份。':
    'Comparing classes or papers. This table describes one paper.',
  '拿來當成績或分班依據。未收齊、判定未全部確認。':
    'Grading or streaming. Not everything is in, and not every judgement is confirmed.',
  預覽整份: 'Preview',
  唯讀預覽: 'read-only preview',
  項教材: 'materials',
  示範資料只有前: 'Demo data covers the first',
  '題，其餘題目在正式資料接上後顯示。': 'questions; the rest appear once real data is connected.',
  已發放: 'Sent',
  發送報告: 'Send reports',
  檢視這: 'View these',
  編輯: 'Edit',
  還有: 'and',
  項限制: 'more limits',
  這次資料的全部限制: 'All limits on this data',
  '學生點開助教看到的第一句話，也最能決定他之後的語氣':
    'The first line the student reads, and the strongest cue for the tone that follows',
  '進階設定：說話方式、教學規則、特定回覆': 'Advanced: speech, teaching rules, set replies',
  收合進階設定: 'Hide advanced settings',
  已釘選: 'Pinned',
  釘選: 'Pin',
  取消釘選: 'Unpin',
  已處理: 'Handled',
  確認已處理: 'Mark handled',
  已標記處理: 'marked handled',
  暫緩: 'Snooze',
  已暫緩: 'snoozed',
  這堂課不再提醒: 'Mute for this session',
  處理這則提醒: 'Handle this alert',
  'AI 已試': 'AI tried',
  種說法: 'approaches',
  重複卡在: 'stuck again on ',
  剛剛還在作答: 'active just now',
  最後動作: 'last seen',
  分鐘前: 'min ago',
  判斷可靠: 'confident',
  判斷普通: 'fairly sure',
  判斷偏弱: 'low confidence',
  已確認處理: 'Handled',
  'AI 連續兩次提示後仍保留同一個錯誤': 'Kept the same error after two AI hints',
  '同一題停留超過門檻，沒有新的作答動作': 'Past the stall threshold with no new work',
  任務目標: 'Goal',
  目前進度: 'Progress',
  '學生的推理／誤解': 'Their reasoning',
  'AI 已嘗試': 'AI tried',
  學生反應: 'How they responded',
  升級原因: 'Why escalated',
  建議下一步: 'Suggested next step',
  推論: 'inferred',
  不確定: 'uncertain',
  看依據: 'Show evidence',
  收合依據: 'Hide evidence',
  介入紀錄: 'Your intervention',
  '調整 AI 助教': 'Adjust the assistant',
  這節課的助教怎麼回應: 'How the assistant answers this session',
  只改這位學生: 'This student only',
  這節課要怎麼幫: 'How it should help',
  提示深度: 'Hint depth',
  只給方向: 'Direction only',
  一步一步問: 'Step by step',
  示範類似題: 'Worked example',
  先要求學生嘗試: 'Attempt first',
  要: 'Yes',
  完整解法: 'Full solution',
  永遠不給: 'Never',
  嘗試後才給: 'After attempts',
  可以給: 'Allowed',
  回合長度: 'Reply length',
  一兩句: 'A line or two',
  適中: 'Medium',
  可以講長一點: 'Longer is fine',
  主動程度: 'Proactivity',
  不主動說話: 'Silent',
  學生問才回: 'On request',
  主動關心: 'Proactive',
  允許來源: 'Sources',
  只用老師教材: 'Teacher material only',
  教材為主: 'Mostly teacher material',
  不限來源: 'Unrestricted',
  套用範圍與時間: 'Scope and duration',
  範圍: 'Scope',
  全班: 'Whole class',
  小組: 'Group',
  個別學生: 'One student',
  維持多久: 'For how long',
  原因: 'Reason',
  '例如：快下課了，允許講細一點': 'e.g. class is nearly over, allow more detail',
  目前生效的調整: 'Active adjustments',
  收回: 'Revoke',
  套用: 'Apply',
  沒有變更: 'Nothing changed',
  已套用新的助教設定: 'assistant settings applied',
  '平台守則（不可關閉）': 'Platform rules (always on)',
  你要怎麼介入: 'How you step in',
  加入對話: 'Join the chat',
  暫停助教: 'Pause the assistant',
  私下提示: 'Private note',
  當面處理: 'Handle in person',
  '學生看得到你，助教退到只記錄': 'The student sees you; the assistant only logs',
  '助教先停，你稍後再決定怎麼接': 'The assistant stops; you decide next',
  '只有學生看得到你的提示，助教不知道': 'Only the student sees your note',
  '你走過去講，這裡只留下紀錄': 'You handle it in the room; this is just the record',
  '交回助教前，請學生用自己的話說一次': 'Have the student say it back before handing over',
  '交接給助教的一句話，例如：他已經懂變號，接下來練兩題就好':
    'A line for the assistant, e.g. they have the sign rule now, two more practice items',
  等學生用自己的話重述後才能交回助教: 'Hand back once the student has said it back',
  交回助教: 'Hand back',
  已交回助教: 'handed back',
  老師已加入: 'Your teacher is here',
  助教繼續陪你: 'The assistant is still with you',
  '助教先暫停，改由老師回你': 'The assistant is paused; your teacher will answer',
  用你自己的話說一次: 'Say it back in your own words',
  '說得出來才代表真的懂了，說完老師就把你交回助教。':
    'Saying it back is what shows it landed. Then you go back to the assistant.',
  '例如：移項的時候符號要相反': 'e.g. moving a term flips its sign',
  要刪除這份教材嗎: 'Delete this material?',
  '刪除後這份教材會從教材庫消失，已經發出去的作業不受影響。':
    'It disappears from the library. Assignments already sent out are unaffected.',
  這份教材也在使用中: 'Also in use by',
  '已離開工作區，選一個身分再進去': 'You have left the workspace — pick a role to go back in',
  '已有機構帳號？': 'Have an organization account?',
  使用機構帳號登入: 'Sign in with an organization account',
  啟用機構帳號: 'Activate organization account',
  機構帳號: 'Organization account',
  密碼: 'Password',
  登入: 'Sign in',
  '登入中…': 'Signing in…',
  使用啟用碼或重設碼: 'Use an activation or reset code',
  一次性代碼: 'One-time code',
  '掃描老師提供的 QR Code，可自動帶入機構帳號與一次性代碼；也可以手動輸入。':
    'Scan the QR Code from your teacher to fill the account and one-time code automatically, or enter them manually below.',
  '已從 QR Code 帶入機構帳號與一次性代碼，請設定新密碼。':
    'The organization account and one-time code were filled from the QR Code. Set your new password.',
  '掃描 QR Code': 'Scan QR Code',
  '將老師提供的 QR Code 對準方框': 'Point the camera at the QR Code from your teacher',
  '這不是有效的 Vispo 機構登入 QR Code': 'This is not a valid Vispo organization sign-in QR Code',
  '無法開啟相機，請允許相機權限或改用手動輸入。':
    'The camera could not be opened. Allow camera access or enter the codes manually.',
  新密碼: 'New password',
  確認新密碼: 'Confirm new password',
  我已閱讀並同意服務條款與隱私權政策: 'I agree to the Terms of Service and Privacy Policy',
  '設定中…': 'Setting password…',
  設定密碼並登入: 'Set password and sign in',
  請找櫃檯或老師重發啟用碼: 'Ask the front desk or your teacher for a new activation code',
  機構帳號格式不正確: 'Organization account format is invalid',
  一次性代碼格式不正確: 'One-time code format is invalid',
  請輸入密碼: 'Enter your password',
  '密碼不可超過 64 個字元': 'Password cannot exceed 64 characters',
  '密碼至少需要 8 個字元': 'Password must be at least 8 characters',
  兩次輸入的密碼不一致: 'Passwords do not match',
  請先同意服務條款與隱私權政策: 'Accept the Terms of Service and Privacy Policy first',
  '暫時無法完成登入，請稍後再試。': 'Sign-in is temporarily unavailable. Try again later.',
};
